module.exports = __webpack_public_path__ + "img/9788956372716.3f5b5d3a.jpg";